// extracted by mini-css-extract-plugin
export default {"labeledCheckbox":"LabeledCheckbox_labeledCheckbox__WZkh+","labeledCheckbox__label--small":"LabeledCheckbox_labeledCheckbox__label--small__PJudd"};